import React, { useEffect, useRef, useState } from "react";
import classes from "./MessagesMobile.module.css";
import { InputWithSearchIcon } from "../../../stories/InputWithSearchIcon/InputWithSearchIcon";
import { Button } from "../../../stories/Button/Button";
import MobileBottomTab from "../../../stories/MobileBottomTab/MobileBottomTab";
import { useHistory } from "react-router-dom";
import {
  coachDemoImg,
  coachDemoImg2,
  bookingIconGray,
  HomeIconGray,
  messageIconGray,
  NotificationIconGray,
  ProfileIconGray,
  BackwardArrow,
  ThreeBlackDots,
  chatSendIcon,
  CalendarIconGray,
  ChatIconRed,
  CancelIconBlack,
} from "../../../constant/imagePath";
import moment from "moment";
import Fonts from "../../../stories/assets/Fonts";
import Colors from "../../../stories/assets/Colors";
import { Col, Container, Row, OverlayTrigger } from "react-bootstrap";
import { ReactSVG } from "react-svg";
import { InputWithButton } from "../../../stories/InputWithButton/InputWithButton";
import { MessageBox } from "./chat/chat";
import StudentDetailsMobile from "./chat/StudentDetailsMobile";
import MessageLessonDetails from "../../../components/Modals/CoachFlow/Messages/LessonDetails/LessonDetail";
import $ from "jquery";
import RoomBox from "../../../stories/RoomBox/RoomBox";

const MessagesMobile = () => {
  const emptyScrollRef = useRef(null);

  const history = useHistory();
  const [menuItem, setMenuItem] = useState("chat");
  const [search, setSearch] = useState("");
  const [sendmessage, setSendMessage] = useState("");
  const [selectedroom, setSelectedroom] = useState();
  const [studentDetailModal, setStudentDetailModal] = useState(false);
  const [showOverlay, setShowOverlay] = useState(false);
  const [lessonDetailModal, setLessonDetailModal] = useState(false);
  const [selectedRoomAllMessages, setSelectedRoomAllMessages] = useState([]);

  const [replyObject, setReplyObject] = useState(null);
  // For Message Container Height
  const replyObjId = document.getElementById('replyObjId')?.offsetHeight



  const users = [
    {
      id: 1,
      img: coachDemoImg,
      name: "Kate Middleton",
      lastMessage: {
        time: moment().format("h:mm A"),
        date: moment().format("MMM DD, YYYY"),
        message: "Hi, John",
        isSeen: false,
        location: "Green Tennis Court",
      },
      event: {
        status: "Lessson request",
      },
      age: 27,
      rating: 4,
      aboutMe:
        "Hello, my name is Kate and I am 28 years old. I just moved to the U.S from Macedonia. I have played competitive tennis 10+ years . I am well aware of all the different types of players there are. I am passionate about the sport.",
      experience: [
        { title: "tennis", label: "Beginner" },
        { title: "box", label: "Beginner" },
      ],
      myCoaches: [
        {
          id: 5,
          name: "Mackenzie McDonald",
          location: "Washington, DC",
          sport: "Tennis",
          rating: 5,
          img: coachDemoImg2,
        },
      ],
    },
    {
      id: 2,
      img: coachDemoImg,
      name: "Jeanie Weesley",
      lastMessage: {
        time: moment().format("h:mm A"),
        date: moment().format("MMM DD, YYYY"),
        message: "Hi, John",
        isSeen: true,
        location: "Green Tennis Court",
      },
      event: {
        status: "Upcoming lesson in 3 days",
      },
      age: 27,
      rating: 4,
      aboutMe:
        "Hello, my name is Jeanie and I am 28 years old. I just moved to the U.S from Macedonia. I have played competitive tennis 10+ years . I am well aware of all the different types of players there are. I am passionate about the sport.",
      experience: [
        { title: "tennis", label: "Beginner" },
        { title: "box", label: "Beginner" },
      ],
      myCoaches: [
        {
          id: 5,
          name: "Mackenzie McDonald",
          location: "Washington, DC",
          sport: "Tennis",
          rating: 5,
          img: coachDemoImg2,
        },
      ],
    },
    {
      id: 3,
      img: coachDemoImg,
      name: "Weesley",
      lastMessage: {
        time: moment().format("h:mm A"),
        date: moment().format("MMM DD, YYYY"),
        message: "Hi, John",
        isSeen: false,
        location: "Green Tennis Court",
      },
      event: {
        status: "Lesson completed",
      },
      age: 27,
      rating: 4,
      aboutMe:
        "Hello, my name is Weesley and I am 28 years old. I just moved to the U.S from Macedonia. I have played competitive tennis 10+ years . I am well aware of all the different types of players there are. I am passionate about the sport.",
      experience: [
        { title: "tennis", label: "Beginner" },
        { title: "box", label: "Beginner" },
      ],
      myCoaches: [
        {
          id: 5,
          name: "Mackenzie McDonald",
          location: "Washington, DC",
          sport: "Tennis",
          rating: 5,
          img: coachDemoImg2,
        },
      ],
    },
  ];
  const messages = [
    {
      id: Math.random() * 1000,
      messageText: "Hi John, I’m interested in practicing my backhand same",
      creadtedAt: "May 25 2022 3:13:05",
      user_id: {
        name: "Kate ",
        isOnline: false,
        img: coachDemoImg,
        id: 123,
      },
    },
    {
      id: Math.random() * 1000,
      messageText: "Hi John, I’m interested in practicing my backhand same 2",
      creadtedAt: "May 25 2022 3:13:05",
      user_id: {
        name: "Kate ",
        isOnline: false,
        img: coachDemoImg,
        id: 123,
      },
    },
    {
      id: Math.random() * 1000,
      messageText: "Hi John, I’m interested in practicing my backhand",
      creadtedAt: "May 24 2022 3:13:05",
      user_id: {
        name: "Kate Middle",
        isOnline: false,
        img: coachDemoImg,
        id: 1234,
      },
    },
    {
      id: Math.random() * 1000,
      messageText: "Hi John, I’m interested in practicing my fronthand",
      booking: "confirmed",
      creadtedAt: "May 23 2022 3:13:05",
      user_id: {
        name: "Kate Middleton",
        isOnline: true,
        img: coachDemoImg,
        id: 12345,
      },
    },
  ];
  const roomChat = (item, i) => {
    setSelectedroom(item);
    setSelectedRoomAllMessages(messages);
  };

  const scrollToBottom = () => {
    emptyScrollRef?.current?.scrollIntoView({
      behavior: "smooth",
      block: "end",
    });
  };

  const CheckHeightAndUpdateMargin = () => {
    $(function () {
      var messageContainerHeight = $(`.${classes.chattingBoxRow}`).height();
      var messageColHeight = $(`.${classes.messageCol}`).height();
      if (messageContainerHeight < messageColHeight) {
        $(`.${classes.scrollToBottomContainer}`).css("margin-bottom", "0px");
      }
      // chattingbox
      scrollToBottom();
    });
  };

  const HandleSendMessage = () => {
    const newArray = [
      ...selectedRoomAllMessages,
      {
        id: Math.random() * 1000,
        messageText: sendmessage,
        creadtedAt: "May 25 2022 3:13:05",
        user_id: {
          name: "Kate ",
          isOnline: false,
          img: coachDemoImg,
          id: 123,
        },
        reply: replyObject,
      },
    ];
    setSelectedRoomAllMessages(newArray);
    setSendMessage("");
    setReplyObject(null);
    CheckHeightAndUpdateMargin();
  };


  console.log('aaa', replyObjId)


  return (
    <div className={[classes.MessagesMobileScreen].join(" ")}>
      {selectedroom ? (
        <Container
          fluid
          className={["p-0", classes.chattingContainer].join(" ")}
        >
          <div
            style={{
              borderBottom: `1px solid ${Colors.neutralShadesOfGainsboro}`,
            }}
            className={[classes.ChatHeader].join(" ")}
          >
            <div className={[classes.dflex, classes.itemscenter].join(" ")}>
              <ReactSVG src={BackwardArrow} onClick={() => setSelectedroom()} />
              <div className={[classes.dflex, classes.ml16].join(" ")}>
                <img
                  className={[classes.headerImg].join(" ")}
                  src={selectedroom?.img}
                  alt="..."
                />
                <p
                  style={{
                    ...Fonts.p2,
                    color: Colors.neutralShadesOfNero,
                    lineHeight: "14px",
                    lineHeight: "20px",
                  }}
                  className={[classes.pl16].join(" ")}
                >
                  1-on-1 Tennis Lesson with <br />{" "}
                  <span
                    style={{
                      ...Fonts.h7,
                      fontSize: "14px",
                      lineHeight: "20px",
                    }}
                  >
                    {selectedroom?.name}
                  </span>
                </p>
              </div>
            </div>
            <OverlayTrigger
              placement={"bottom"}
              show={showOverlay}
              trigger={["click"]}
              overlay={
                <div className={[classes.overlayBox]}>
                  <p
                    style={{ color: Colors.neutralShadesOfNero, ...Fonts.p2 }}
                    className={[classes.overLayItems]}
                    onClick={() => setLessonDetailModal(true)}
                  >
                    Lesson details
                  </p>
                  <p style={{ color: Colors.neutralShadesOfNero, ...Fonts.p2 }}>
                    Cancel lesson
                  </p>
                </div>
              }
              delay={{ show: 100, hide: 100 }}
              onToggle={() => setShowOverlay(!showOverlay)}
            >
              <ReactSVG src={ThreeBlackDots} />
            </OverlayTrigger>
          </div>

          <div
            className={[
              classes.chatMiddleSection,
              `${replyObject && classes?.replyWithChatMiddleSection}`,
            ].join(" ")}
            style={
              { ...(replyObject !== null && { height: `(100vh - ${replyObjId})` }), }

            }
          >
            <div
              className={[classes.chatMiddleInnerDiv, classes.messageCol].join(
                " "
              )}
            >
              {selectedroom?.event?.status === "Lessson request" && (
                <Row className={[classes.pb8].join(" ")}>
                  <Col xs={6} className={[classes.declineBtnColumn].join(" ")}>
                    <Button
                      label="Decline"
                      customStyle={{ ...Fonts.b2, width: "100%" }}
                    />
                  </Col>
                  <Col xs={6}>
                    <Button
                      label="Accept"
                      primary={true}
                      customStyle={{ ...Fonts.b2, width: "100%" }}
                    />
                  </Col>
                </Row>
              )}
              {selectedroom?.event?.status === "Upcoming lesson in 3 days" && (
                <>
                  <Button
                    primary={false}
                    label={"Cancel lesson"}
                    customStyle={{ ...Fonts.b2, width: "100%" }}
                  />
                </>
              )}
              {selectedroom?.event?.status === "Lesson completed" && <div />}
              <div>
                <div>
                  {selectedRoomAllMessages.map((item, i) => {
                    return (
                      <div
                        style={{
                          marginBottom:
                            item?.user_id?.id ==
                              selectedRoomAllMessages[i + 1]?.user_id?.id
                              ? "8px"
                              : "24px",
                        }}
                      >
                        {item?.creadtedAt ==
                          selectedRoomAllMessages[i - 1]?.creadtedAt ? (
                          <></>
                        ) : item?.booking ? (
                          <>
                            <p
                              style={{
                                ...Fonts.p2,
                                color: Colors.neutralShadesOfDimGray,
                              }}
                              className={[
                                classes.textcenter,
                                classes.mb4,
                                classes.bookingPara,
                              ].join(" ")}
                            >
                              <ReactSVG
                                src={CalendarIconGray}
                                className={[classes.bookingSvgicon].join(" ")}
                              />
                              Booking {item?.booking}
                            </p>

                            <ul
                              className={[
                                "p-0",
                                classes.mb24,
                                classes.dflex,
                                classes.contentcenter,
                              ].join(" ")}
                            >
                              <li
                                style={{
                                  ...Fonts.p2,
                                  color: Colors.neutralShadesOfDimGray,
                                }}
                                className={[classes.textcenter].join(" ")}
                              >
                                {item?.creadtedAt}
                              </li>
                              <li
                                style={{
                                  ...Fonts.p2,
                                  color: Colors.neutralShadesOfDimGray,
                                }}
                                className={[classes.textcenter].join(" ")}
                              >
                                <span
                                  className={[classes.dots].join(" ")}
                                  style={{
                                    backgroundColor:
                                      Colors.neutralShadesOfPinkSwan,
                                  }}
                                />
                                {item?.creadtedAt}
                              </li>
                            </ul>
                          </>
                        ) : (
                          <p
                            style={{
                              ...Fonts.p2,
                              color: Colors.neutralShadesOfDimGray,
                            }}
                            className={[classes.textcenter, classes.mb24].join(
                              " "
                            )}
                          >
                            {item?.creadtedAt}
                          </p>
                        )}

                        <MessageBox
                          item={item}
                          isImage={
                            item?.user_id?.id ===
                              selectedRoomAllMessages[i + 1]?.user_id?.id
                              ? false
                              : true
                          }
                          showName={
                            item?.user_id?.id ==
                              selectedRoomAllMessages[i - 1]?.user_id?.id
                              ? false
                              : true
                          }
                          i={i}
                          onClick={() => setStudentDetailModal(true)}
                          setReplyObject={(e) => {
                            setReplyObject(e)
                          }}
                        />
                      </div>
                    );
                  })}
                </div>
                <div
                  className={classes.scrollToBottomContainer}
                  ref={emptyScrollRef}
                />
              </div>
            </div>

            <div
              style={{
                borderTop:
                  replyObject && `1px solid ${Colors.neutralShadesOfGainsboro}`,
              }}
              className={[classes.inputSendChatDiv].join(" ")}
              id='replyObjId'


            >
              {replyObject && (
                <div className={[classes.replyMessageDiv]}
                  style={{ background: Colors.white }}
                >
                  <div>
                    <ReactSVG
                      src={CancelIconBlack}
                      onClick={() => {
                        setReplyObject(null)
                      }}
                    />
                  </div>
                  <p
                    className={[classes.replyMessage]}
                    style={{
                      color: Colors.neutralShadesOfNero,
                      ...Fonts.p1,
                      borderLeft: `2px solid ${Colors.mainBlue}`,
                    }}
                  >
                    {replyObject?.messageText}{" "}
                  </p>
                </div>
              )}

              <InputWithButton
                type="text"
                state={sendmessage}
                setter={setSendMessage}
                placeholder="Type a message"
                btnIcon={chatSendIcon}
                buttonStyle={{ backgroundColor: Colors.white }}
                customStyle={{ width: "100%" }}
                onClick={() => {
                  HandleSendMessage();
                }}
              />
            </div>
          </div>
        </Container>
      ) : (
        <>
          <Container fluid className={["p-0"].join(" ")}>
            <Row className={["g-0", classes.Header].join(" ")}>
              <Col md={12}>
                <h2
                  style={{
                    ...Fonts.h2,
                    fontSize: "26px",
                    lineHeight: "32px",
                    color: Colors.neutralShadesOfNero,
                  }}
                >
                  Inbox
                </h2>
              </Col>
              <Col md={12}>
                <InputWithSearchIcon state={search} setter={setSearch} />
              </Col>
            </Row>

            <Row className={["gx-0", classes.userChatMainDiv].join(" ")}>
              <Col md={12}>
                {users.length > 0 ? (
                  users?.map((item, i) => {
                    return (
                      <div style={{
                        borderBottom:
                          i !== users.length - 1 &&
                          `1px solid ${Colors.neutralShadesOfGainsboro}`,

                      }}>
                        <RoomBox item={item} i={i} onClick={(e) => roomChat(e, i)} selectedroom={selectedroom} />
                      </div>
                    );
                  })
                ) : (
                  <div className={[classes.noRoomDiv]}>
                    <div className={[classes.noRoomInnerDiv]}>
                      <ReactSVG
                        className={[classes.nochatIcon].join(" ")}
                        src={ChatIconRed}
                      />
                      <h3
                        className={[classes.textcenter, classes.mb8].join(" ")}
                        style={{
                          ...Fonts.h3,
                          color: Colors.neutralShadesOfNero,
                          fontSize: "24px",
                          lineHeight: "32px",
                        }}
                      >
                        You have no messages yet
                      </h3>
                      <p
                        className={[classes.textcenter].join(" ")}
                        style={{
                          ...Fonts.p1,
                          color: Colors.neutralShadesOfDimGray,
                        }}
                      >
                        As soon as the student decides to write you a message,
                        it will appear here.
                      </p>
                    </div>
                  </div>
                )}
              </Col>
            </Row>
          </Container>
          <div className={classes.BottomTab}>
            <MobileBottomTab state={menuItem}
            />
          </div>
        </>
      )
      }

      {
        studentDetailModal && (
          <StudentDetailsMobile
            studentDetails={selectedroom}
            show={studentDetailModal}
            setShow={() => setStudentDetailModal(false)}
          />
        )
      }
      {console.log(selectedroom)}

      {
        lessonDetailModal && (
          <MessageLessonDetails
            show={lessonDetailModal}
            setShow={setLessonDetailModal}
          />
        )
      }
    </div >
  );
};
export default MessagesMobile;
